// src/pages/Opportunities.js
import React, { useState } from "react";
import { Box, Paper, Typography, Divider } from "@mui/material";
import PatientHeader from "../../components/PatientHeader/PatientHeader";

// Example data for the patient profile
const exampleProfile = {
  dob: "01/01/1980",
  lastPcpVisit: "06/01/2024",
  opportunityScore: "Score",
  erVisits: 0,
  admits: 0,
  age: 44,
};

const Opportunities = () => {
  const [patientProfile] = useState(exampleProfile);

  return (
    <div style={{ margin: "50px auto", width: "80%" }}>
      <Paper elevation={3} style={{ padding: "20px" }}>
        {/* Reuse the Patient Header */}
        <PatientHeader
          dob={patientProfile.dob}
          lastPcpVisit={patientProfile.lastPcpVisit}
          opportunityScore={patientProfile.opportunityScore}
          erVisits={patientProfile.erVisits}
          admits={patientProfile.admits}
          age={patientProfile.age}
        />
        <Divider />

        {/* Quality Section */}
        <Box marginTop={4}>
          <Typography variant="h5" align="center">
            Quality
          </Typography>
          <Typography align="center" marginTop={2}>
            No quality measures needing attention.
          </Typography>
        </Box>
        <Divider />

        {/* Suspect Conditions Section */}
        <Box marginTop={4}>
          <Typography variant="h5" align="center">
            Suspect Conditions
          </Typography>
          <Typography align="center" marginTop={2}>
            No suspect conditions found.
          </Typography>
        </Box>
      </Paper>
    </div>
  );
};

export default Opportunities;
